// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FDum","tabsBox":"styles_tabsBox__3wsw3","createButton":"styles_createButton__3tIUB"};